import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state để render fallback UI ở lần tiếp theo
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Trong thực tế có thể log lỗi này lên dịch vụ tracking (như Sentry)
    console.error('Uncaught error in React component:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      const isProd =
        typeof process !== 'undefined' &&
        typeof process.env !== 'undefined' &&
        process.env.NODE_ENV === 'production';

      return (
        <div style={{ padding: '20px', textAlign: 'center', color: '#cc0000', fontFamily: 'sans-serif' }}>
          <h2>Oops! Đã xảy ra lỗi trên giao diện.</h2>
          <p>Xin lỗi vì sự bất tiện này. Vui lòng tải lại trang.</p>
          {!isProd && (
            <pre style={{ textAlign: 'left', background: '#f8d7da', padding: '10px', borderRadius: '4px', overflowX: 'auto' }}>
              {this.state.error?.toString()}
            </pre>
          )}
          <button onClick={() => window.location.reload()} style={{ padding: '8px 16px', marginTop: '15px', cursor: 'pointer' }}>
            Tải lại trang
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
